import { application } from "./application"

import MediaPlayerController from "./media_player_controller"
import MultiselectController from "./multiselect_controller"
import ResourceUploadController from "./resource_upload_controller"
import DirectUploadController from "./direct_upload_controller"
import OrderingController from "./ordering_controller"
import ColorController from "./color_controller"
import DemoController from "./demo_controller"
import AudioController from "./audio_controller"
import WavesurferAudioController from "./wavesurfer_audio_controller"
import CollectionController from "./collection_controller"
import StateDropdownController from "./state_dropdown_controller"
import ClipboardController from "./clipboard_controller"
import PasswordValidationController from "./password_validation_controller"
import ProfileController from "./profile_controller"
import NavbarUnderlineController from "./navbar_underline_controller";
import CcExpandController from "./cc_expand_controller";
import NavbarMenuController from "./navbar_menu_controller";
import ModalVideoController from "./modal_video_controller";
import FormModalController from "./form_modal_controller";
import HeatmapController from "./heatmap_controller";
import EngagementChartController from "./engagement_chart_controller";
import LibrarySearchController from "./library_search_controller";
import FlowbiteTabsController from "./flowbite_tabs_controller";
import ProvisionalRegistrationController from "./provisional_registration_controller";
import CalendarTooltipController from "./calendar_tooltip_controller";
import ScrollTrackerController from "./scroll_tracker_controller";
import PushSubscriptionController from "./push_subscription_controller";
import PwaInstallController from "./pwa_install_controller";
import EnableNotificationsController from "./enable_notifications_controller";
import DashboardChartController from "./dashboard_chart_controller";
import NotificationFormController from "./notification_form_controller";
import OrganizationFormController from "./organization_form_controller";
import TriggerFormController from "./trigger_form_controller";
import JwtAuthController from "./jwt_auth_controller";
import HistoryController from "./history_controller";
import MyTriesFeedbackDrawerController from "./my_tries_feedback_drawer_controller";
import TrySaveFxController from "./try_save_fx_controller";
import NavbarCelebrateController from "./navbar_celebrate_controller";
import TriedFxController from "./tried_fx_controller";
import MyTriesFilterController from "./my_tries_filter_controller";
import AutoSubmitController from "./auto_submit_controller";
import SectionViewTrackerController from "./section_view_tracker_controller";
import TryShareController from "./try_share_controller";

application.register("media-player", MediaPlayerController)
application.register("multiselect", MultiselectController)
application.register("resource-upload", ResourceUploadController)
application.register("direct-upload", DirectUploadController)
application.register("ordering", OrderingController)
application.register("color", ColorController)
application.register("demo", DemoController)
application.register("audio", AudioController)
application.register("wavesurfer-audio", WavesurferAudioController)
application.register("collection", CollectionController)
application.register("state-dropdown", StateDropdownController)
application.register("clipboard", ClipboardController)
application.register("password-validation", PasswordValidationController)
application.register("profile", ProfileController)
application.register("navbar-underline", NavbarUnderlineController);
application.register("cc-expand", CcExpandController);
application.register("navbar-menu", NavbarMenuController);
application.register("modal-video", ModalVideoController);
application.register("form-modal", FormModalController);
application.register("heatmap", HeatmapController);
application.register("engagement-chart", EngagementChartController);
application.register("library-search", LibrarySearchController);
application.register("flowbite-tabs", FlowbiteTabsController);
application.register("provisional-registration", ProvisionalRegistrationController);
application.register("calendar-tooltip", CalendarTooltipController);
application.register("scroll-tracker", ScrollTrackerController);
application.register("pwa-install", PwaInstallController);
application.register("enable-notifications", EnableNotificationsController);
application.register("dashboard-chart", DashboardChartController);
application.register("push-subscription", PushSubscriptionController);
application.register("notification-form", NotificationFormController);
application.register("organization-form", OrganizationFormController);
application.register("trigger-form", TriggerFormController);
application.register("jwt-auth", JwtAuthController);
application.register("history", HistoryController);
application.register("my-tries-feedback-drawer", MyTriesFeedbackDrawerController);
application.register("try-save-fx", TrySaveFxController);
application.register("navbar-celebrate", NavbarCelebrateController);
application.register("tried-fx", TriedFxController);
application.register("my-tries-filter", MyTriesFilterController);
application.register("auto-submit", AutoSubmitController);
application.register("section-view-tracker", SectionViewTrackerController);
application.register("try-share", TryShareController);
